<template>
    <div>
        <div
            class="modal fade show"
            tabindex="-1"
            style="display: block"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div
                        class="modal-header d-none d-sm-block border-0 mb-0 pb-0"
                    >
                        <button type="button" class="close" @click="closeModal">
                            &times;
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="col-12">
                            <div class="form-group">
                                <label for="task-label" class="form-label">
                                    Choose a label
                                    <span class="label-optional">
                                        - Or type a new one</span
                                    >
                                </label>
                                <div class="position-relative">
                                    <input
                                        id="task-label"
                                        ref="selectionInput"
                                        type="text"
                                        class="form-control wfh-custom-selector-input"
                                        @focusin="selecting = true"
                                        @keydown.esc="stopSelecting"
                                        @keyup="searchItem"
                                        v-model="value"
                                        autocomplete="off"
                                        :required="required"
                                    />
                                    <button
                                        class="btn btn-link custom-no-padding-btn"
                                        v-if="isSelected"
                                        type="button"
                                        @click="resetValue"
                                    >
                                        <i class="fa fa-times-circle"></i>
                                    </button>
                                    <div
                                        class="position-absolute wfh-custom-selector"
                                        v-if="selecting"
                                    >
                                        <div v-if="managingItem">
                                            <ManageItem
                                                :title="title"
                                                v-on:returnToSelectList="
                                                    returnToSelectList
                                                "
                                                v-on:updateItem="updateItem"
                                                v-on:deleteItem="deleteItem"
                                                :item="selectedItem"
                                            />
                                        </div>
                                        <div v-else>
                                            <div>
                                                <SelectorItem
                                                    v-for="item in filteredOptions"
                                                    :selectorText="item.name"
                                                    :selected="
                                                        item.name === value
                                                    "
                                                    :key="item.id"
                                                    :itemId="item.id"
                                                    @selectItem="
                                                        selectItem(
                                                            item.name,
                                                            item.id
                                                        )
                                                    "
                                                    @manageItem="
                                                        manageItem(item.id)
                                                    "
                                                />
                                            </div>
                                            <div
                                                class="d-flex justify-content-center py-2"
                                            >
                                                <button
                                                    class="btn btn-outline-dark"
                                                    style="
                                                        padding: 8px 15px !important;
                                                    "
                                                    @click="managingItem = true"
                                                >
                                                    {{ createBtnText }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-center">
                                <button
                                    class="btn btn-outline-dark"
                                    style="padding: 8px 15px !important"
                                    @click="closeModal"
                                >
                                    Done
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade show"></div>
    </div>
</template>

<script>
import SelectorItem from "../../Misc/CustomSelector/SelectorItem";
import ManageItem from "../../Misc/CustomSelector/ManageItem";

export default {
    props: ["options", "selected", "title", "required"],
    components: { ManageItem, SelectorItem },

    data() {
        return {
            filteredOptions: this.options.slice(),
            selecting: false,
            managingItem: false,
            itemId: null,
            value: this.selected || "",
            searchText: "",
            isSelected: false,
        };
    },

    watch: {
        selected() {
            this.value = this.selected;

            const selection = this.filteredOptions.filter((item) => {
                return item.name === this.value;
            });

            this.isSelected = selection.length > 0;
        },

        options() {
            this.filteredOptions = this.options;
        },
    },

    computed: {
        createBtnText() {
            return this.filteredOptions.length > 0 || this.options.length === 0
                ? `Create a new ${this.selectorTitle}`
                : `Create a "${this.searchText}" ${this.selectorTitle}`;
        },

        selectedItem() {
            const itemId = this.itemId;

            if (itemId == null && this.filteredOptions.length > 0) {
                return "";
            }

            return itemId !== null
                ? this.filteredOptions.filter((item) => {
                      return item.id === this.itemId;
                  })[0]
                : this.searchText
                ? this.searchText
                : "";
        },

        selectorTitle() {
            return this.title ?? "label";
        },
    },

    methods: {
        stopSelecting(e) {
            e.preventDefault();

            this.selecting = false;
            this.$nextTick(() => {
                this.$refs["selectionInput"].blur();
            });
        },

        returnToSelectList() {
            this.itemId = null;
            this.managingItem = false;
        },

        selectItem(val, id) {
            this.value = val;
            this.$emit("selectItem", val, id);
            this.selecting = false;
        },

        manageItem(itemId) {
            this.itemId = itemId;
            this.managingItem = true;
        },

        updateItem(val, itemId) {
            this.$emit("updateLabel", val, itemId);
        },

        deleteItem(itemId) {
            this.$emit("deleteItem", itemId);
            this.itemId = null;
            this.managingItem = false;
        },

        searchItem(e) {
            this.searchText = e.target.value;

            this.filteredOptions = this.options.filter((item) => {
                const optionText = item.name.toLowerCase();
                return optionText.includes(this.searchText.toLocaleLowerCase());
            });
        },

        resetValue() {
            this.$emit("resetValue");
            this.value = "";
            this.searchText = "";
            this.filteredOptions = this.options.splice();
        },

        closeModal() {
            this.$emit("closeModal");
        },
    },
};
</script>

<style scoped lang="scss">
.custom-no-padding-btn {
    padding: 8px 0 !important;
    color: #000 !important;
    position: absolute;
    top: 0;
    right: 8px;
}

.wfh-custom-selector {
    width: 100%;
    background: #fff;
    z-index: 999;
    border: 1px solid #eff1f5;
    padding: 8px 0;
    border-radius: 0 0 8px 8px !important;
    color: #495057;
    outline: 0;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
}

.wfh-custom-selector-input {
    border-radius: 0 !important;
    border: 1px solid #eff1f5;
    box-shadow: none !important;
}

.form-label {
    color: #3a414c;
    font-family: "Open Sans";
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.5px;
    line-height: 22px;
}

.label-optional {
    color: #808fa4;
    font-family: Lato;
    font-size: 13px;
    letter-spacing: 0;
    line-height: 20px;
    font-weight: 400;
}
</style>
